// extracted by mini-css-extract-plugin
export var subtitleText = "adm-title-module--subtitle-text--PLFWi";